import React from 'react';
import { FormattedMessage } from 'react-intl';

import Modal from '@/components/Modals/Modal';

import {
  BodyWrapper,
  CustomerElement,
  Label
} from './styles';

// NOT USED
const CustomerSelectModal = (props) => {
  const {
    open = true,
    selected = {},
    onSelect,
    list,
    setOpen,
  } = props;

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      handleApply={null}
      style={{minHeight: '200px', maxHeight: '520px'}}
      height="auto"
      title={<FormattedMessage id="cmme.selectCustomer" defaultMessage="Select customer" />}
    >
      <BodyWrapper>
        {!!list?.length && list.map(CustomerObj => {
          const { customerName, customerId } = CustomerObj;
          return (
            <CustomerElement
              key={customerId}
              selected={selected.customerId === customerId}
              onClick={onSelect.bind(null, CustomerObj)}
            >
              <Label>{ customerId }</Label>
              <Label>{ customerName }</Label>
            </CustomerElement>
          );
        })}
      </BodyWrapper>
    </Modal>
  )
};

export default React.memo(CustomerSelectModal);
